<template>
  <div>
    <app-form
      :form-data="form_config"
      default-label-width="100px"
      @confirm="confirm"
      @cancel="cancel"
    />
  </div>
</template>

<script>
export default {
  components: {
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      form_config: require('./model/form-config')(this),
    };
  },
  created() {
    this.addEvent();
  },
  methods: {
    addEvent() {
      const { brand_type, mid, space_url } = this.form_config;
      brand_type.on = {
        change: () => {
          const is_mid = brand_type.value === 'mid';
          mid.hidden = !is_mid;
          space_url.hidden = is_mid;
        },
      };
    },
    confirm(params) {
      this.$emit('confirm', params);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
